import Swal from "sweetalert2";
import { Col } from 'react-bootstrap';
import { Field, Form } from 'react-final-form';
import React, { useEffect, useState } from 'react';
import { Button } from '@/shared/components/Button';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import FormField from '@/shared/components/form/FormField';
import renderSelectField from '@/shared/components/form/Select';
import { CheckBoxField } from '@/shared/components/form/CheckBox';
import renderCheckBoxField from '@/shared/components/form/CheckBox';
import { Card, CardBody, CardTitleWrap, CardTitle, CardSubhead } from '@/shared/components/Card';
import { CollectionCardinalDirectionEnum, CollectionCategoryEnum, BatchJobStorageEnum, BatchJobVCPUsEnum } from "Enums";
import { FormButtonToolbar, FormContainer, FormGroup, FormGroupField, FormGroupLabel } from '@/shared/components/form/FormElements';

const validate = (values) => {
    const errors = {};
    
    if (values.hosting_bucket && (values.hosting_bucket.toLowerCase().startsWith('s3://') || values.hosting_bucket.toLowerCase().endsWith('/')))
        errors.hosting_bucket = 'Hosting bucket cannot start with "s3" or end with "/"';

    if (values.nadir_tiles_directory_uri && !values.nadir_tiles_directory_uri.toLowerCase().startsWith('s3://'))
        errors.nadir_tiles_directory_uri = 'Invalid S3 directory address';

    if (values.north_tiles_directory_uri && !values.north_tiles_directory_uri.toLowerCase().startsWith('s3://'))
        errors.north_tiles_directory_uri = 'Invalid S3 directory address';

    if (values.east_tiles_directory_uri && !values.east_tiles_directory_uri.toLowerCase().startsWith('s3://'))
        errors.east_tiles_directory_uri = 'Invalid S3 directory address';

    if (values.south_tiles_directory_uri && !values.south_tiles_directory_uri.toLowerCase().startsWith('s3://'))
        errors.south_tiles_directory_uri = 'Invalid S3 directory address';

    if (values.west_tiles_directory_uri && !values.west_tiles_directory_uri.toLowerCase().startsWith('s3://'))
        errors.west_tiles_directory_uri = 'Invalid S3 directory address';

    return errors;
};

const required = value => (value !== undefined ? undefined : 'Required')

const CreateObliqueTilesetAssets = () => {
    const [nadirMissions, setNadirMissions] = useState();
    const [northMissions, setNorthMissions] = useState();
    const [eastMissions, setEastMissions] = useState();
    const [southMissions, setSouthMissions] = useState();
    const [westMissions, setWestMissions] = useState();

    let collection_info = {
        "stac_extensions": [
            "https://stac-extensions.github.io/eo/v1.0.0/schema.json",
            "https://stac-extensions.github.io/projection/v1.0.0/schema.json",
            "https://stac-extensions.github.io/view/v1.0.0/schema.json"
        ],
        "title": "{Constellation} {CollectionID}",
        "description": "HD aerial imagery collection of Canada. Maintained by FastMap",
        "license": "proprietary",
        "summaries": {
            "datetime": {},
            "platform": [],
            "constellation": [],
            "instruments": [],
            "view:off_nadir": {
                "minimum": 0,
                "maximum": 0
            },
            "view:sun_elevation": {
                "minimum": 0,
                "maximum": 0
            },
            "gsd": {
                "minimum": 0,
                "maximum": 0
            },
            "proj:epsg": [],
            "eo:cloud_cover": {
                "minimum": 0,
                "maximum": 0
            },
            "eo:bands": [
                {
                    "name": "band1",
                    "common_name": "red",
                    "center_wavelength": 625,
                    "full_width_half_max": 700
                },
                {
                    "name": "band2",
                    "common_name": "green",
                    "center_wavelength": 500,
                    "full_width_half_max": 565
                },
                {
                    "name": "band3",
                    "common_name": "blue",
                    "center_wavelength": 450,
                    "full_width_half_max": 485
                },
                {
                    "name": "band4",
                    "common_name": "alpha"
                }
            ]
        },
        "keywords": [
            "platform:manned",
            "platform:unmanned"
        ],
        "providers": [
            {
                "name": "FastMap Inc.",
                "roles": [
                    "producer",
                    "processor",
                    "licensor",
                    "host"
                ],
                "description": "Spatial data library managed by FastMap.",
                "url": "https://fastmap.ai"
            }
        ]
    };

    let item_info = {
        "stac_version": "1.0.0",
        "stac_extensions": [
            "https://stac-extensions.github.io/eo/v1.0.0/schema.json",
            "https://stac-extensions.github.io/projection/v1.0.0/schema.json",
            "https://stac-extensions.github.io/view/v1.0.0/schema.json",
            "https://stac-extensions.github.io/processing/v1.0.0/schema.json",
            "https://stac-extensions.github.io/card4l/v1.0.0/optical/schema.json",
            "https://stac-extensions.github.io/web-map-links/v1.2.0/schema.json"
        ],
        "providers": [
            {
                "name": "FastMap Inc.",
                "description": "Add company description here",
                "roles": [
                    "producer",
                    "processor",
                    "licensor",
                    "host"
                ],
                "url": "https://fastmap.ai"
            },
            {
                "name": "Licnesee Holder",
                "description": "Add licensee description here",
                "roles": [
                    "licensee"
                ],
                "url": "https://"
            }
        ]
    }

    let item_properties = {
        "description": "{platform} {constellation} {collectionID} captured by {Producer} and licensed by {Licensor}",
        "created": "2024-05-21T20:17:57.150260",
        "updated": "2024-05-21T20:17:57.150260",
        "constellation": "aerial",
        "eo_bands": 4,
        "eo_no_data": "alpha",
        "prj_centroid": [
            -100.0582134139518,
            51.158650916715736
        ],
        "unit": "meter",
        "compression": "deflate",
        "data_type": "uint8",
        "file_data_type": "tiff",
        "file_bits_per_sample": 8,
        "geometric_accuracy_description": "geometric accuracy * GSD"
    }

    const copyNadirDirectory = (event, form) => {
        let name = event.target.name;
        let checked = event.target.checked;
        let direction = name.split('_')[0];

        if (checked) {
            let nadir_directory = form.getFieldState('nadir_tiles_directory_uri').value;
            form.change(`${direction}_tiles_directory_uri`, nadir_directory);
        } else {
            form.change(`${direction}_tiles_directory_uri`, '');
        }
    }

    const submitNewRequest = (values) => {
        let createCOGAsset = { ...values };
        createCOGAsset.batch_job_vcpus = createCOGAsset.batch_job_vcpus.value;
        createCOGAsset.batch_job_storage = createCOGAsset.batch_job_storage.value;
        createCOGAsset.nadir_mission_id = createCOGAsset.nadir_mission_id.value;
        createCOGAsset.north_mission_id = createCOGAsset.north_mission_id.value;
        createCOGAsset.east_mission_id = createCOGAsset.east_mission_id.value;
        createCOGAsset.south_mission_id = createCOGAsset.south_mission_id.value;
        createCOGAsset.west_mission_id = createCOGAsset.west_mission_id.value;
        createCOGAsset.processing_level = createCOGAsset.processing_level.value;
        createCOGAsset.derived_from = createCOGAsset.derived_from.value;
        createCOGAsset.elevation_model = createCOGAsset.elevation_model.value;
        createCOGAsset.vertical_crs = createCOGAsset.vertical_crs.value;
        createCOGAsset.platform = createCOGAsset.platform.value;
        createCOGAsset.processing_software = createCOGAsset.processing_software.value;
        createCOGAsset.processing_facility = createCOGAsset.processing_facility.value;
        createCOGAsset.processing_lineage = createCOGAsset.processing_lineage.value;
        createCOGAsset.collection_info = JSON.parse(createCOGAsset.collection_info);
        createCOGAsset.item_info = JSON.parse(createCOGAsset.item_info);
        createCOGAsset.item_properties = JSON.parse(createCOGAsset.item_properties);
        createCOGAsset.rotate_by_orientation = createCOGAsset.rotate_by_orientation;

        Swal.fire({
            title: 'Warning!',
            text: `This will start a job in the background to create the COG asset and it may take some time. Are you sure you want to continue?`,
            icon: 'warning',
            confirmButtonText: 'Yes!',
            cancelButtonText: 'No!',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                AdminInterface.instance.createObliqueTilesetAssets(createCOGAsset).then(() => {
                    withReactContent(Swal).fire({
                        icon: 'success',
                        title: 'Success',
                        text: `Creating COG Asset from tiles in the following directories is started: \n 
                                ${createCOGAsset.north_tiles_directory_uri} \n 
                                ${createCOGAsset.east_tiles_directory_uri} \n 
                                ${createCOGAsset.south_tiles_directory_uri} \n 
                                ${createCOGAsset.west_tiles_directory_uri})`,
                    });
                }).catch((error) => {
                    withReactContent(Swal).fire({
                        icon: 'error',
                        title: 'Error',
                        html: error?.response?.data?.detail,
                    });
                })
            }
        });
    }

    const GetMissions = () => {
        AdminInterface.instance.getMissions().then((response) => {
            let nadirMissionsList = response.data.filter(mission => mission.collection.category === CollectionCategoryEnum.oblique_photo_tileset && mission.collection.cardinal_direction === CollectionCardinalDirectionEnum.Nadir)
                .map(function (mission) {
                    return { value: mission.id, label: `${mission.collection.name} ${mission.name}` }
                });

            let northMissionsList = response.data.filter(mission => mission.collection.category === CollectionCategoryEnum.oblique_photo_tileset && mission.collection.cardinal_direction === CollectionCardinalDirectionEnum.North)
                .map(function (mission) {
                    return { value: mission.id, label: `${mission.collection.name} ${mission.name}` }
                });

            let eastMissionsList = response.data.filter(mission => mission.collection.category === CollectionCategoryEnum.oblique_photo_tileset && mission.collection.cardinal_direction === CollectionCardinalDirectionEnum.East)
                .map(function (mission) {
                    return { value: mission.id, label: `${mission.collection.name} ${mission.name}` }
                });

            let southMissionsList = response.data.filter(mission => mission.collection.category === CollectionCategoryEnum.oblique_photo_tileset && mission.collection.cardinal_direction === CollectionCardinalDirectionEnum.South)
                .map(function (mission) {
                    return { value: mission.id, label: `${mission.collection.name} ${mission.name}` }
                });

            let westMissionsList = response.data.filter(mission => mission.collection.category === CollectionCategoryEnum.oblique_photo_tileset && mission.collection.cardinal_direction === CollectionCardinalDirectionEnum.West)
                .map(function (mission) {
                    return { value: mission.id, label: `${mission.collection.name} ${mission.name}` }
                });

            setNadirMissions(nadirMissionsList);
            setNorthMissions(northMissionsList);
            setEastMissions(eastMissionsList);
            setSouthMissions(southMissionsList);
            setWestMissions(westMissionsList);
        }).catch(() => {
            withReactContent(Swal).fire({
                icon: 'error',
                title: 'Error',
                html: 'Error in getting missions.'
            });
        });
    }

    useEffect(() => {
        GetMissions();
    }, []);

    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <CardTitleWrap>
                        <CardTitle>Create Oblique Tileset Asset</CardTitle>
                        <CardSubhead>This form submits a request that converts tiles in four S3 directories (one for each cardinal direction) into COGs and add them as a assets.</CardSubhead>
                    </CardTitleWrap>
                    {(nadirMissions && northMissions && eastMissions && southMissions && westMissions) && <Form onSubmit={submitNewRequest} validate={validate} initialValues={{
                        batch_job_vcpus: { value: 8, label: '8' },
                        batch_job_storage: { value: 1, label: '1 TB' },
                        processing_level: { value: 'L1', label: 'L1' },
                        processing_lineage: { value: 'S1', label: 'S1' },
                        processing_facility: { value: 'Local', label: 'Local' },
                        processing_software: { value: "Pix4D", label: 'Pix4D' },
                        derived_from: { value: 'Frame', label: 'Frame' },
                        elevation_model: { value: undefined, label: 'None' },
                        vertical_crs: { value: undefined, label: 'None' },
                        platform: { value: 'manned', label: 'Manned' },
                        sensor_calibration: '2020Q2',
                        geometric_accuracy: 1,
                        nva_geometric_accuracy: 0,
                        vva_geometric_accuracy: 0,
                        eo_cloud_cover: 0,
                        eo_cloud_shadow: 0,
                        view_off_nadir: 0,
                        view_sun_elevation: 36,
                        collection_info: JSON.stringify(collection_info, undefined, 4),
                        item_info: JSON.stringify(item_info, undefined, 4),
                        item_properties: JSON.stringify(item_properties, undefined, 4),
                        rotate_by_orientation: false
                    }} >
                        {({ handleSubmit, form }) => (
                            <FormContainer horizontal onSubmit={handleSubmit}>
                                <FormGroup>
                                    <FormGroupLabel>Virtual CPUs</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="batch_job_vcpus" component={renderSelectField} validate={required}
                                            options={Object.entries(BatchJobVCPUsEnum).map(([label, value]) => ({ value, label }))} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Storage</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="batch_job_storage" component={renderSelectField} validate={required}
                                            options={Object.entries(BatchJobStorageEnum).map(([label, value]) => ({ value, label }))} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Nadir Frames Mission</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="nadir_mission_id" component={renderSelectField} options={nadirMissions} validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Nadir Frames Directory</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="nadir_tiles_directory_uri" component={FormField} placeholder="For example: s3://Toronto_SU_2018/Nadir" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>North Mission</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="north_mission_id" component={renderSelectField} options={northMissions} validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>North Obliques Directory</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="north_tiles_directory_uri" component={FormField} placeholder="For example: s3://Toronto_SU_2018/North" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Same as 'Nadir' directory</FormGroupLabel>
                                    <FormGroupField>
                                        <CheckBoxField
                                            name="north_as_nadir_directory"
                                            onChange={(event) => copyNadirDirectory(event, form)} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>East Mission</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="east_mission_id" component={renderSelectField} options={eastMissions} validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>East Obliques Directory</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="east_tiles_directory_uri" component={FormField} placeholder="For example: s3://Toronto_SU_2018/East" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Same as 'Nadir' directory</FormGroupLabel>
                                    <FormGroupField>
                                        <CheckBoxField
                                            name="east_as_nadir_directory"
                                            onChange={(event) => copyNadirDirectory(event, form)} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>South Mission</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="south_mission_id" component={renderSelectField} options={southMissions} validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>South Obliques Directory</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="south_tiles_directory_uri" component={FormField} placeholder="For example: s3://Toronto_SU_2018/South" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Same as 'Nadir' directory</FormGroupLabel>
                                    <FormGroupField>
                                        <CheckBoxField
                                            name="south_as_nadir_directory"
                                            onChange={(event) => copyNadirDirectory(event, form)} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>West Mission</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="west_mission_id" component={renderSelectField} options={westMissions} validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>West Obliques Directory</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="west_tiles_directory_uri" component={FormField} placeholder="For example: s3://Toronto_SU_2018/West" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Same as 'Nadir' directory</FormGroupLabel>
                                    <FormGroupField>
                                        <CheckBoxField
                                            name="west_as_nadir_directory"
                                            onChange={(event) => copyNadirDirectory(event, form)} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Footprint Shapefile URI (*.Shp/*.geojson/*.json file)</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="footprint_shapefile_uri" component={FormField} placeholder="For example: s3://Toronto_SU_2018/Footprint.shp" />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Images Require Rotation by Direction</FormGroupLabel>
                                    <FormGroupField>
                                        <Field
                                        name='rotate_by_orientation'
                                        type="checkbox"
                                        component={renderCheckBoxField}
                                        />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Hosting Bucket</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="hosting_bucket" component={FormField} placeholder="For example: fm-tms" />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Source SRS</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="source_srs" component={FormField} type="number" placeholder="For example: 4326" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Sensor Calibration</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="sensor_calibration" component={FormField} placeholder="Sensor Calibration" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Processing Level</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="processing_level" component={renderSelectField}
                                            options={[
                                                { value: 'RAW', label: 'RAW' },
                                                { value: 'L0', label: 'L0' },
                                                { value: 'L1', label: 'L1' },
                                                { value: 'L2', label: 'L2' },
                                                { value: 'L3', label: 'L3' },
                                                { value: 'L4', label: 'L4' },
                                            ]} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Processing Lineage</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="processing_lineage" component={renderSelectField}
                                            options={[
                                                { value: 'S1', label: 'S1' },
                                                { value: 'S2', label: 'S2' },
                                                { value: 'S3', label: 'S3' }
                                            ]} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Processing Facility</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="processing_facility" component={renderSelectField}
                                            options={[
                                                { value: 'Local', label: 'Local' },
                                                { value: 'Cloud', label: 'Cloud' }
                                            ]} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Processing Software</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="processing_software" component={renderSelectField}
                                            options={[
                                                { value: "CaptureOne", label: 'CaptureOne' },
                                                { value: "MatchAT", label: 'MatchAT' },
                                                { value: "OrthoMaster", label: 'OrthoMaster' },
                                                { value: "OrthoVista", label: 'OrthoVista' },
                                                { value: "Pix4D", label: 'Pix4D' },
                                                { value: "Agisoft", label: 'Agisoft' },
                                                { value: "FastMap Cloud", label: 'FastMap Cloud' },
                                                { value: "Proprietary", label: 'Proprietary' }
                                            ]} />

                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Derived From</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="derived_from" component={renderSelectField}
                                            options={[
                                                { value: 'Frame', label: 'Frame' },
                                                { value: 'Terrain', label: 'Terrain' },
                                                { value: 'Point Cloud', label: 'Point Cloud' },
                                            ]} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Elevation Model</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="elevation_model" component={renderSelectField}
                                            options={[
                                                { value: undefined, label: 'None' },
                                                { value: 'SRTM90', label: 'SRTM90' },
                                                { value: 'SRTM30', label: 'SRTM30' },
                                                { value: 'DEM Terrain Item', label: 'DEM Terrain Item' },
                                                { value: 'DSM Terrain Item', label: 'DSM Terrain Item' },
                                            ]} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Geometric Accuracy</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="geometric_accuracy" component={FormField} type="number" placeholder="Geometric Accuracy" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Vegetated Geometric Accuracy</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="vva_geometric_accuracy" component={FormField} type="number" placeholder="Vegetated Geometric Accuracy" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Non-Vegetated Geometric Accuracy</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="nva_geometric_accuracy" component={FormField} type="number" placeholder="Non-Vegetated Geometric Accuracy" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Vertical CRS</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="vertical_crs" component={renderSelectField}
                                            options={[
                                                { value: undefined, label: 'None' },
                                                { value: 'CGVD28 / HT2.0', label: 'CGVD28 / HT2.0' },
                                                { value: 'CGVD2013 / CGG2013', label: 'CGVD2013 / CGG2013' }
                                            ]} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Platform</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="platform" component={renderSelectField}
                                            options={[
                                                { value: 'manned', label: 'Manned' },
                                                { value: 'unmanned', label: 'Unmanned' },
                                                { value: 'CityScan', label: 'CityScan' },
                                                { value: 'StreetScan', label: 'StreetScan' },
                                                { value: 'SiteScan', label: 'SiteScan' },
                                                { value: 'Satellite', label: 'Satellite' },
                                            ]} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Cloud Cover</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="eo_cloud_cover" component={FormField} type="number" placeholder="Cloud Cover" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Cloud Shadow</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="eo_cloud_shadow" component={FormField} type="number" placeholder="Cloud Shadow" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Off Nadir</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="view_off_nadir" component={FormField} type="number" placeholder="Off Nadir" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Sun Elevation</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="view_sun_elevation" component={FormField} type="number" placeholder="Sun Elevation" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Collection Info</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="collection_info" component="textarea" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Item Info</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="item_info" component="textarea" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Item Properties</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="item_properties" component="textarea" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormButtonToolbar>
                                    <Button variant="primary" type="submit">Submit</Button>
                                    <Button variant="secondary" type="button" onClick={form.reset}>
                                        Cancel
                                    </Button>
                                </FormButtonToolbar>
                            </FormContainer>
                        )}
                    </Form>}
                </CardBody>
            </Card>
        </Col>
    );
};

export default CreateObliqueTilesetAssets;